import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["src", "thumb", "showPlayIcon", "autoplay", "onPlay", "onPause", "onDuration", "__isFacebook__"];
import React, { useState, useRef } from "react";
import ReactPlayer from "react-player";
import useInputState from "../../util/hooks/useInputState";

/**
 * @todo
 *  the __isFacebook__ is a temporary fix necessary due to
 *  some unvorteilhafte decitions in the less file ("facebook"-dependet), which I (luke)
 *  theoretically could fix, but do not want.
 *
 *  - REMOVE "facebook" dependency/knowledge of the video component, because
 *    the video component will not receive the type itself anymore (as it should not care)
 *  - add options to pass to react player
 *  - add callback handlers (like handlePlayStart etc for tracking)
 */
import { jsx as _jsx } from "react/jsx-runtime";
var Video = function Video(_ref) {
  var src = _ref.src,
    thumb = _ref.thumb,
    _ref$showPlayIcon = _ref.showPlayIcon,
    showPlayIcon = _ref$showPlayIcon === void 0 ? false : _ref$showPlayIcon,
    autoplay = _ref.autoplay,
    onPlay = _ref.onPlay,
    onPause = _ref.onPause,
    onDuration = _ref.onDuration,
    _ref$__isFacebook__ = _ref.__isFacebook__,
    __isFacebook__ = _ref$__isFacebook__ === void 0 ? false : _ref$__isFacebook__,
    props = _objectWithoutProperties(_ref, _excluded);
  if (thumb && autoplay !== false) {
    autoplay = true;
  }

  // State
  var _useInputState = useInputState(props.muted),
    _useInputState2 = _slicedToArray(_useInputState, 2),
    muted = _useInputState2[0],
    setMuted = _useInputState2[1];
  var _useState = useState(autoplay),
    _useState2 = _slicedToArray(_useState, 2),
    playing = _useState2[0],
    setPlaying = _useState2[1];
  var timerRef = useRef();

  // Controls
  var handlePlay = function handlePlay() {
    timerRef.current && clearTimeout(timerRef.current);
    setPlaying(true);
    onPlay && onPlay();
  };
  var handlePause = function handlePause() {
    setPlaying(false);
    onPause && onPause();
  };
  var handleDuration = function handleDuration(duration) {
    if (thumb && playing === false && !muted) {
      // The browser didn't allow us to autoplay the video, so we have to mute it and try again
      setMuted(true);
      timerRef.current = setTimeout(function () {
        return setPlaying(true);
      }, 100);
    }
    onDuration && onDuration(duration);
  };

  // Classname
  var facebookClassName = __isFacebook__ ? " facebook" : "";
  var thumbClassName = thumb && playing === undefined ? " thumb" : "";
  var iconClass = showPlayIcon ? " has-play-icon" : "";
  var wrapperClass = "video-responsive-wrapper".concat(facebookClassName).concat(thumbClassName).concat(iconClass);
  return /*#__PURE__*/_jsx("div", {
    className: wrapperClass,
    children: /*#__PURE__*/_jsx(ReactPlayer, _objectSpread(_objectSpread({}, props), {}, {
      className: "react-player",
      width: "100%",
      height: "100%",
      url: src,
      light: thumb,
      playing: playing,
      muted: muted,
      controls: true,
      playsinline: autoplay,
      config: {
        youtube: {
          playerVars: {
            showinfo: 0,
            ref: 0
          }
        },
        facebook: {
          appId: "247176471959250"
        }
      },
      onPlay: handlePlay,
      onPause: handlePause,
      onDuration: handleDuration
    }))
  });
};
export default Video;
//# sourceMappingURL=index.js.map